import React from 'react';
import PlaceAutocompleteInput from './PlaceAutocompleteInput';
import { TRAVEL_MODES } from '../constants';
import { formatDuration } from '../services/time';
import Image from '../images';

import './SearchBox.scss';

const SearchBox = ({
  routes,
  travelMode,
  destinations,
  onTravelModeChange,
  onOriginAddressChange,
  onDestinationAddressChange,
  onRemoveDestination,
  onAddDestination,
  onClearAll,
}) => {
  return (
    <div className="search-box">
      <div className="travel-mode-filter-btns">
        {TRAVEL_MODES.map((mode) => {
          const duration = formatDuration(routes[mode]?.[0]?.duration);
          return (
            <button key={mode} className={travelMode === mode ? 'active' : ''} onClick={() => onTravelModeChange(mode)}>
              <Image type={mode} />
              {duration && <span>{duration}</span>}
            </button>
          );
        })}
      </div>
      <div className="input-address-group">
        <div className="origin-input">
          <PlaceAutocompleteInput placeholder="Enter origin" onPlaceSelect={onOriginAddressChange} />
        </div>
        <Image type="OriginDot" />
        {destinations.map((_, index) => (
          <div key={index} className="destination-input">
            <Image type="DestinationDot" />
            <PlaceAutocompleteInput
              placeholder={`Enter destination ${index + 1}`}
              onPlaceSelect={(place) => onDestinationAddressChange(place, index)}
            />
            <button className="remove-destination" onClick={() => onRemoveDestination(index)}>
              <Image type="Remove" />
            </button>
          </div>
        ))}
        <button className="add-destination" onClick={onAddDestination}>
          <Image type="Add" /> Add Destination
        </button>
      </div>
      <div className="buttons">
        <button className="btn btn-clear" onClick={onClearAll}>
          Clear All
          <Image type="Clear" />
        </button>
      </div>
    </div>
  );
};

export default SearchBox;
